import { render, staticRenderFns } from "./Exception06.vue?vue&type=template&id=ec0e93ea&scoped=true&"
import script from "./Exception06.vue?vue&type=script&lang=js&"
export * from "./Exception06.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0e93ea",
  null
  
)

export default component.exports